import { render, staticRenderFns } from "./vigilantes.vue?vue&type=template&id=38e2702e&scoped=true"
import script from "./vigilantes.vue?vue&type=script&lang=js"
export * from "./vigilantes.vue?vue&type=script&lang=js"
import style0 from "./vigilantes.vue?vue&type=style&index=0&id=38e2702e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e2702e",
  null
  
)

export default component.exports